export * from './activate.view';
